module.exports = __webpack_public_path__ + "static/media/decor2.14648c3c.jpg";